<script>

	/* IMPORT: SVELTE/KIT */
	import { onMount, tick } from 'svelte';
	import { page } from '$app/stores';
  
	/* IMPORT: 3RD-PARTY */
	
	/* IMPORT: CUSTOM JS */
	import { restProp }	from '$lib/script/restprop.js';

	export let base = 
	{ 
		//id: `link-${ Math.random() * 10000 }`,
		class: { 
			prefix: true, 
			value: 'link' 
		}
	};

	let link = null;
	
	const linkAnchorScrollSmooth = () =>
	{	
		
		// Handle with css - if set in css
		if ( getComputedStyle( document.documentElement ).scrollBehavior === 'auto' ) return;
		
		// Handle w/ script if not set in css
		link.addEventListener( 'click', ( _event ) => 
		{
			_event.preventDefault();
			_event.stopPropagation();

			document.querySelector( `[name=${ link.getAttribute('href').replace('#', '')  }]` ).scrollIntoView({
				behavior: 'smooth',
				block: 'start',
				// inline: 'nearest'
			});

		});
	}

	const linkHrefFilter = () =>
	{

		// Handle junk...
		if ( typeof $$restProps?.href === 'undefined' ) return;
		
		// Handle convert URL to HREF
		if ( $$restProps?.url ) 
		{
			$$restProps.href = $$restProps?.url;
			delete( $$restProps?.url );
		}

		// Handle url anchors
		if ( $$restProps?.href?.startsWith('#') ) linkAnchorScrollSmooth();

		// Handle url filtering
		// $$restProps.href = CREATE_FILTER_FUNCTION_UTIL( ... );

		// Handle target _blank and apply noopener for security reasons
		if ( $$restProps?.target === '_blank' ) $$restProps.rel = 'noopener';

	}

	/* Svelte Methods */
	
	onMount( async () =>
	{
		// #Await...
		//await tick();

		$$restProps = restProp({
			type: 'Link',
			restProp: $$restProps,
			base: base,
			required: ['title']
		});

		linkHrefFilter();

	});
  
</script>

<!-- svelte-ignore a11y-missing-content -->
<!-- svelte-ignore a11y-missing-attribute -->
{#if $$restProps?.name && $$restProps?.name.startsWith( '#' ) }
	<a bind:this={ link } data-id='mffnK4' {...$$restProps} />
{:else}
	<a bind:this={ link } data-id='mffnK4' {...$$restProps}>
		<slot />
	</a>
{/if}



<style lang='scss'>

   :global( :root ) {
		--link-clr: var(--clr-red-static);
		--link-clr-hover: var(--clr-red-static);
		--link-text-decoration: underline;
		--link-cursor: pointer;
	}

	:global( a:not( .unstyled ) )
	{
		color: var(--link-clr);
		text-decoration: var(--link-text-decoration);
		cursor: var(--link-cursor);
	}

	:global( a:not( .unstyled ):hover ),
	:global( a:not( .unstyled ):focus )
	{
		color: var(--link-clr-hover);
	}

</style>